import React from 'react';
import Button from '../../../components/ui/Button';

const CategoryFilter = ({ categories, activeCategory, onCategoryChange }) => {
  return (
    <div className="category-filter-container w-full overflow-x-auto">
      <div className="flex gap-2 md:gap-3 pb-2 min-w-max">
        {categories?.map((category) => (
          <Button
            key={category?.id}
            variant={activeCategory === category?.id ? 'default' : 'outline'}
            size="sm"
            onClick={() => onCategoryChange(category?.id)}
            className="flex-shrink-0 touch-target transition-smooth active:scale-96"
          >
            {category?.name}
            {category?.count > 0 && (
              <span className={`ml-2 px-2 py-0.5 rounded-full text-xs font-medium ${
                activeCategory === category?.id 
                  ? 'bg-primary-foreground/20 text-primary-foreground' 
                  : 'bg-muted text-muted-foreground'
              }`}>
                {category?.count}
              </span>
            )}
          </Button>
        ))}
      </div>
    </div>
  );
};

export default CategoryFilter;